export default __webpack_public_path__ + "static/media/pyramidgame.9fd9e103.jpg";